var React = require('react');

function ChevronRight16x16 (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Size=16x16, Inverted=off"},React.createElement("path",{"id":"Vector","d":"M4.5 15l7-6.5v-1L4.5 1","stroke":"currentColor","strokeWidth":"2","strokeMiterlimit":"10","strokeLinecap":"round"})));
}

ChevronRight16x16.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = ChevronRight16x16;

ChevronRight16x16.default = ChevronRight16x16;
